import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Department } from "@common/utils/graphql";
import { ViewDepartmentContent } from "./ViewDepartmentContent";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  department: Department;
  refetchDepartments: () => void;
}

export const ViewDepartmentSheet = ({
  isOpen,
  onClose,
  department,
  refetchDepartments,
}: Props) => {
  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={onClose}>
        {department && (
          <ViewDepartmentContent
            refetchDepartments={refetchDepartments}
            department={department}
            onClose={onClose}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};
